export enum AdminPageContentType {
  Active = 'active',
  Deleted = 'deleted',
  Rooms = 'rooms'
}
